export function subscribe(ids) {
    return {
        type: 'MARKETS_SUBSCRIBE',
        ids: Array.isArray(ids) ? ids : [ ids ]
    };
}

export function unsubscribe(ids) {
    return {
        type: 'MARKETS_UNSUBSCRIBE',
        ids: Array.isArray(ids) ? ids : [ ids ]
    };
}
